/**
 * 固定资产 API
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	// 获取资产列表
	getFixedAssets() {
		return Ajax.get("/fixed-assets")
	},
	// 按状态获取资产
	getFixedAssetsByStatus(status) {
		return Ajax.get(`/fixed-assets/by-status/${status}`)
	},
	// 获取资产统计
	getFixedAssetStatistics() {
		return Ajax.get("/fixed-assets/statistics")
	},
	// 生成资产编码
	generateAssetCode() {
		return Ajax.get("/fixed-assets/generate-code")
	},
	// 创建资产
	createFixedAsset(params = {}) {
		return Ajax.post("/fixed-assets", params)
	},
	// 更新资产
	updateFixedAsset(id, params = {}) {
		return Ajax.put(`/fixed-assets/${id}`, params)
	},
	// 删除资产
	deleteFixedAsset(id) {
		return Ajax.delete(`/fixed-assets/${id}`)
	},
	// 报废资产
	scrapFixedAsset(id, remark) {
		return Ajax.post(`/fixed-assets/${id}/scrap`, Qs.stringify({ remark }))
	},
	// 计提折旧
	calculateDepreciation() {
		return Ajax.post("/fixed-assets/calculate-depreciation")
	},
	// 删除最近折旧
	deleteLastDepreciation() {
		return Ajax.delete("/fixed-assets/depreciation/latest")
	},
	// 获取资产类别
	getFixedAssetCategories() {
		return Ajax.get("/fixed-assets/categories")
	},
	// 获取折旧方法
	getDepreciationMethods() {
		return Ajax.get("/fixed-assets/depreciation-methods")
	}
}
